import { render, staticRenderFns } from "./deptUseWarning.vue?vue&type=template&id=a88352ba&scoped=true"
import script from "./deptUseWarning.vue?vue&type=script&lang=js"
export * from "./deptUseWarning.vue?vue&type=script&lang=js"
import style0 from "./deptUseWarning.vue?vue&type=style&index=0&id=a88352ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88352ba",
  null
  
)

export default component.exports